export const ON_TRADE_SOCKET_CHANGE = 'ON_TRADE_STOCK_CHANGE';

export const onTradeSocketChange = datum => (dispatch) => {
  const params = {
    type: ON_TRADE_SOCKET_CHANGE,
    payload: datum,
  };
  
  dispatch(params);
};

export const ON_PRICE_SOCKET_CHANGE = 'ON_PRICE_SOCKET_CHANGE';

export const onPriceSocketChange = datum => (dispatch) => {
  const params = {
    type: ON_PRICE_SOCKET_CHANGE,
    payload: datum,
  };
  
  dispatch(params);
};

const INITIAL_STATE = {
  runningTrade: [],
};

const tradeSocket = (state = INITIAL_STATE, { type, payload } = {}) => {
  const datum = payload;
  switch (type) {
    case ON_TRADE_SOCKET_CHANGE:
      if (datum.ticker) {
        state.runningTrade.unshift(datum);
        if (state.runningTrade.length > 20) state.runningTrade.pop();
      }
      return {
        ...state,
        runningTrade: [...state.runningTrade]
      };
    default:
      return state;
  }
};
export default tradeSocket;
